var chunkToChildrenMap = {
	"37547": [
		12915,
		16141,
		8370,
		46512,
		38495,
		9924,
		60448,
		91956,
		60918
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));